<template>
  <component v-bind:is="component" v-bind:redirect-token="redirectToken" />
</template>

<script>
import LoginForm from '@/views/login/TheLoginForm.vue'
import LoginRedirected from '@/views/login/TheLoginRedirected.vue'

export default {
  name: 'TheLogin',
  props: {
    /**
     * 転送時の認証引き継ぎトークン
     */
    redirectToken: {
      type: String,
      default: null,
    },
  },
  computed: {
    /**
     * 対象コンポーネント
     */
    component: function () {
      return this.redirectToken ? LoginRedirected : LoginForm
    },
  },
}
</script>
